import { ApiParameter,  get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const customerSpireUrl = "api/v1/customerspire/customerid";

export interface GetCustomerSpireParameters extends ApiParameter {
    customerId?: string;
}

export interface CustomerSpireModel extends BaseModel {
    userName?: string;
    customerNumber?: string;
    logoImagePath?: string;
}

export function getCustomerSpire(parameter: GetCustomerSpireParameters) {
    return get<CustomerSpireModel>(`${customerSpireUrl}/${parameter.customerId}`);
}